// import React, { useState } from 'react';
// import Box from "@mui/material/Box";
// import SwipeableDrawer from "@mui/material/SwipeableDrawer";
// import Drawer from "@mui/material/Drawer";
// import List from "@mui/material/List";
// import Divider from "@mui/material/Divider";
// import ListItem from "@mui/material/ListItem";
// import ListItemButton from "@mui/material/ListItemButton";
// import ListItemIcon from "@mui/material/ListItemIcon";
// import ListItemText from "@mui/material/ListItemText";
// import Typography from "@mui/material/Typography";
// import Avatar from "@mui/material/Avatar";
// import IconButton from "@mui/material/IconButton";
// import Collapse from "@mui/material/Collapse";
// import useMediaQuery from "@mui/material/useMediaQuery";
// import Dialog from "@mui/material/Dialog";
// import DialogActions from "@mui/material/DialogActions";
// import DialogContent from "@mui/material/DialogContent";
// import DialogContentText from "@mui/material/DialogContentText";
// import DialogTitle from "@mui/material/DialogTitle";
// import Button from "@mui/material/Button";
// import CircularProgress from "@mui/material/CircularProgress";
// import Tooltip from "@mui/material/Tooltip";

// import DashboardIcon from "@mui/icons-material/Dashboard";
// import PeopleIcon from "@mui/icons-material/People";
// import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
// import SmsIcon from "@mui/icons-material/Sms";
// import AccessTimeIcon from "@mui/icons-material/AccessTime";
// import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
// import VaccinesIcon from "@mui/icons-material/Vaccines";
// import MasksIcon from "@mui/icons-material/Masks";
// import HealingIcon from "@mui/icons-material/Healing";
// import FactoryIcon from "@mui/icons-material/Factory";
// import FitnessCenterIcon from "@mui/icons-material/FitnessCenter";
// import SportsGymnasticsIcon from "@mui/icons-material/SportsGymnastics";
// import RestaurantIcon from "@mui/icons-material/Restaurant";
// import LoyaltyIcon from "@mui/icons-material/Loyalty";
// import CardMembershipIcon from "@mui/icons-material/CardMembership";
// import Diversity3Icon from "@mui/icons-material/Diversity3";
// import DisplaySettingsIcon from "@mui/icons-material/DisplaySettings";
// import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
// import ExpandMore from "@mui/icons-material/ExpandMore";
// import ExpandLess from "@mui/icons-material/ExpandLess";
// import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
// import ChevronRightIcon from "@mui/icons-material/ChevronRight";
// import MenuIcon from "@mui/icons-material/Menu";
// import CloseIcon from "@mui/icons-material/Close";

// import { Link, useLocation, useNavigate } from "react-router-dom";
// import ClinicLogo from "../../Assets/logo.png";
// import { getDecryptedData, getDecryptedUserType } from '../../Utils/LoginUserDetails.js/LoginUserSavedDetails';

// // Theme colors
// const SIDEBAR_BG = "#122b2a";
// const SIDEBAR_HOVER = "#1a3d3b";
// const SIDEBAR_ACTIVE = "#1c7c6c";
// const SIDEBAR_TEXT = "rgba(255,255,255,0.7)";
// const SIDEBAR_TEXT_ACTIVE = "#fff";
// const SIDEBAR_BORDER = "rgba(255,255,255,0.08)";
// const TEAL_ACCENT = "#2ec4a5";

// // Breakpoints
// const DESKTOP_BP = "(min-width:1200px)";
// const TABLET_BP = "(min-width:768px) and (max-width:1199px)";
// const MOBILE_BP = "(max-width:767px)";

// export default function RiteAdminSidebar({ onSidebarChange }) {
//   const [mobileOpen, setMobileOpen] = useState(false);
//   const [openLogoutDialog, setOpenLogoutDialog] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [collapsed, setCollapsed] = useState(false);
//   const [openSection, setOpenSection] = useState(null);

//   const isDesktop = useMediaQuery(DESKTOP_BP);
//   const isTablet = useMediaQuery(TABLET_BP);
//   const isMobile = useMediaQuery(MOBILE_BP);

//   const location = useLocation();
//   const navigate = useNavigate();
//   const LoginUserDetails = getDecryptedData();
//   const LoginUserType = getDecryptedUserType();

//   const fullName = `${LoginUserDetails?.fname || ""} ${LoginUserDetails?.lname || ""}`.trim();

//   // On tablet, always collapsed. On desktop, user toggles.
//   const isCollapsed = isTablet ? true : collapsed;
//   const drawerWidth = isCollapsed ? 64 : 240;

//   // Notify parent of width changes
//   React.useEffect(() => {
//     if (onSidebarChange) {
//       if (isMobile) {
//         onSidebarChange(0);
//       } else {
//         onSidebarChange(drawerWidth);
//       }
//     }
//   }, [drawerWidth, isMobile, onSidebarChange]);

//   const handleLogoutConfirm = () => {
//     setLoading(true);
//     setTimeout(() => {
//       sessionStorage.clear();
//       setLoading(false);
//       setOpenLogoutDialog(false);
//       navigate("/rite-admin-signin");
//     }, 2000);
//   };

//   const isActive = (path) => location.pathname === path;

//   const commonItems = [
//     { text: "Dashboard", icon: <DashboardIcon />, path: "/rite-admin/dashboard" },
//     { text: "Clients", icon: <PeopleIcon />, path: "/rite-admin/patient-list" },
//     { text: "Rite Staff", icon: <SmsIcon />, path: "/rite-admin/send-messages" },
//     { text: "Demo Bokings", icon: <CalendarMonthIcon />, path: "/rite-admin/appointments" },
//     { text: "Emails", icon: <AccessTimeIcon />, path: "/rite-admin/my-schedule" },
//   ];

//   const riteItems = [
//     { text: "Rite Staff", path: "/rite-admin/rite-staff", icon: <MasksIcon /> },
//     { text: "Rite Departments", path: "/rite-admin/rite-departments", icon: <HealingIcon /> },
//   ];



//   const NavItem = ({ item }) => {
//     const button = (
//       <ListItem disablePadding sx={{ mb: 0.25 }}>
//         <ListItemButton
//           component={Link}
//           to={item.path}
//           onClick={() => isMobile && setMobileOpen(false)}
//           sx={{
//             borderRadius: "8px",
//             mx: isCollapsed ? 0.5 : 1,
//             px: isCollapsed ? 1.5 : 2,
//             py: 1,
//             minHeight: 42,
//             justifyContent: isCollapsed ? "center" : "flex-start",
//             backgroundColor: isActive(item.path) ? SIDEBAR_ACTIVE : "transparent",
//             color: isActive(item.path) ? SIDEBAR_TEXT_ACTIVE : SIDEBAR_TEXT,
//             "&:hover": {
//               backgroundColor: isActive(item.path) ? SIDEBAR_ACTIVE : SIDEBAR_HOVER,
//               color: SIDEBAR_TEXT_ACTIVE,
//             },
//             transition: "all 0.2s ease",
//           }}
//         >
//           <ListItemIcon
//             sx={{
//               color: isActive(item.path) ? SIDEBAR_TEXT_ACTIVE : SIDEBAR_TEXT,
//               minWidth: isCollapsed ? 0 : 36,
//               mr: isCollapsed ? 0 : 1,
//               "& .MuiSvgIcon-root": { fontSize: 20 },
//             }}
//           >
//             {item.icon}
//           </ListItemIcon>
//           {!isCollapsed && (
//             <ListItemText
//               primary={item.text}
//               primaryTypographyProps={{
//                 fontSize: 13,
//                 fontWeight: isActive(item.path) ? 600 : 400,
//                 letterSpacing: 0.2,
//               }}
//             />
//           )}
//         </ListItemButton>
//       </ListItem>
//     );

//     return isCollapsed ? (
//       <Tooltip title={item.text} placement="right" arrow>
//         {button}
//       </Tooltip>
//     ) : (
//       button
//     );
//   };

//   const CollapsibleSection = ({ title, icon, sectionKey, items }) => (
//     <>
//       <ListItem disablePadding sx={{ mb: 0.25 }}>
//         <ListItemButton
//           onClick={() => {
//             if (isCollapsed) return;
//             setOpenSection(openSection === sectionKey ? null : sectionKey);
//           }}
//           sx={{
//             borderRadius: "8px",
//             mx: isCollapsed ? 0.5 : 1,
//             px: isCollapsed ? 1.5 : 2,
//             py: 1,
//             minHeight: 42,
//             justifyContent: isCollapsed ? "center" : "flex-start",
//             color: SIDEBAR_TEXT,
//             "&:hover": { backgroundColor: SIDEBAR_HOVER, color: SIDEBAR_TEXT_ACTIVE },
//           }}
//         >
//           <ListItemIcon
//             sx={{
//               color: SIDEBAR_TEXT,
//               minWidth: isCollapsed ? 0 : 36,
//               mr: isCollapsed ? 0 : 1,
//               "& .MuiSvgIcon-root": { fontSize: 20 },
//             }}
//           >
//             {icon}
//           </ListItemIcon>
//           {!isCollapsed && (
//             <>
//               <ListItemText primary={title} primaryTypographyProps={{ fontSize: 13, fontWeight: 500 }} />
//               {openSection === sectionKey ? <ExpandLess sx={{ fontSize: 18 }} /> : <ExpandMore sx={{ fontSize: 18 }} />}
//             </>
//           )}
//         </ListItemButton>
//       </ListItem>
//       {!isCollapsed && (
//         <Collapse in={openSection === sectionKey} timeout="auto" unmountOnExit>
//           <List disablePadding sx={{ pl: 1.5 }}>
//             {items.map((item) => (
//               <NavItem key={item.text} item={item} />
//             ))}
//           </List>
//         </Collapse>
//       )}
//     </>
//   );

//   const list = () => (
//     <Box
//       sx={{
//         width: isMobile ? 280 : drawerWidth,
//         height: "100vh",
//         display: "flex",
//         flexDirection: "column",
//         backgroundColor: SIDEBAR_BG,
//         transition: "width 0.3s ease",
//         overflow: "hidden",
//       }}
//     >
//       {/* Logo Header */}
//       <Box
//         sx={{
//           display: "flex",
//           alignItems: "center",
//           gap: 1.5,
//           px: isCollapsed ? 1.5 : 2.5,
//           py: 2.5,
//           borderBottom: `1px solid ${SIDEBAR_BORDER}`,
//         }}
//       >
//         <Box
//           sx={{
//             width: 36,
//             height: 36,
//             borderRadius: "10px",
//             backgroundColor: SIDEBAR_ACTIVE,
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             flexShrink: 0,
//           }}
//         >
//           <img src={ClinicLogo} alt="Logo" style={{ width: 22, height: 22, objectFit: "contain", filter: "brightness(10)" }} />
//         </Box>
//         {!isCollapsed && (
//           <Box sx={{ overflow: "hidden", flex: 1 }}>
//             <Typography sx={{ fontSize: 14, fontWeight: 700, color: "#fff", letterSpacing: 0.5, lineHeight: 1.2 }}>
//               Rite Marketing
//             </Typography>
//             <Typography sx={{ fontSize: 9, color: "rgba(255,255,255,0.45)", textTransform: "uppercase", letterSpacing: 2 }}>
//               Automation Platform
//             </Typography>
//           </Box>
//         )}
//         {/* Mobile close button */}
//         {isMobile && (
//           <IconButton onClick={() => setMobileOpen(false)} sx={{ color: SIDEBAR_TEXT, ml: "auto" }}>
//             <CloseIcon fontSize="small" />
//           </IconButton>
//         )}
//       </Box>

//       {/* Navigation */}
//       <Box
//         sx={{
//           flex: 1,
//           overflowY: "auto",
//           py: 1.5,
//           "&::-webkit-scrollbar": { width: 4 },
//           "&::-webkit-scrollbar-thumb": { backgroundColor: "rgba(255,255,255,0.1)", borderRadius: 4 },
//         }}
//       >
//         <List disablePadding>
//           {commonItems.map((item) => (
//             <NavItem key={item.text} item={item} />
//           ))}
//         </List>

//         {LoginUserType === "admin" && (
//           <>
//             <Divider sx={{ borderColor: SIDEBAR_BORDER, mx: 2, my: 1.5 }} />
//             <List disablePadding>
//               <CollapsibleSection title="Rite Management" icon={<HealingIcon />} sectionKey="clinic" items={riteItems} />

//               <NavItem item={{ text: "Enquiries", icon: <Diversity3Icon />, path: "/rite-admin/all-enquiries" }} />
//             </List>
//           </>
//         )}
//       </Box>

//       {/* Doctor Profile & Footer */}
//       <Box sx={{ borderTop: `1px solid ${SIDEBAR_BORDER}`, p: isCollapsed ? 1 : 1.5 }}>
//         {!isCollapsed && fullName && (
//           <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 1.5, px: 1 }}>
//             <Avatar
//               sx={{
//                 width: 36,
//                 height: 36,
//                 backgroundColor: "rgba(46,196,165,0.2)",
//                 color: TEAL_ACCENT,
//                 fontSize: 13,
//                 fontWeight: 700,
//               }}
//             >
//               {LoginUserDetails?.fname?.[0]?.toUpperCase() || "D"}
//               {LoginUserDetails?.lname?.[0]?.toUpperCase() || "R"}
//             </Avatar>
//             <Box sx={{ minWidth: 0 }}>
//               <Typography noWrap sx={{ fontSize: 13, fontWeight: 600, color: "#fff" }}>
//                 {fullName}
//               </Typography>
//               <Typography sx={{ fontSize: 11, color: "rgba(255,255,255,0.4)" }}>
//                 {LoginUserType === "admin" ? "Administrator" : "Physician"}
//               </Typography>
//             </Box>
//           </Box>
//         )}

//         <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", px: isCollapsed ? 0 : 1 }}>
//           <Tooltip title="Logout" placement="right">
//             <ListItemButton
//               onClick={() => setOpenLogoutDialog(true)}
//               sx={{
//                 borderRadius: "8px",
//                 py: 0.75,
//                 px: 1,
//                 minHeight: 0,
//                 justifyContent: isCollapsed ? "center" : "flex-start",
//                 color: "rgba(255,255,255,0.4)",
//                 "&:hover": { color: "#ef4444", backgroundColor: "rgba(239,68,68,0.1)" },
//               }}
//             >
//               <PowerSettingsNewIcon sx={{ fontSize: 18, mr: isCollapsed ? 0 : 1 }} />
//               {!isCollapsed && <Typography sx={{ fontSize: 12 }}>Logout</Typography>}
//             </ListItemButton>
//           </Tooltip>

//           {isDesktop && (
//             <IconButton
//               onClick={() => setCollapsed(!collapsed)}
//               sx={{ color: "rgba(255,255,255,0.4)", "&:hover": { color: "#fff", backgroundColor: SIDEBAR_HOVER }, p: 0.75 }}
//             >
//               {collapsed ? <ChevronRightIcon sx={{ fontSize: 18 }} /> : <ChevronLeftIcon sx={{ fontSize: 18 }} />}
//             </IconButton>
//           )}
//         </Box>
//       </Box>
//     </Box>
//   );

//   return (
//     <Box>
//       {/* Mobile hamburger button */}
//       {isMobile && (
//         <IconButton
//           onClick={() => setMobileOpen(true)}
//           sx={{
//             position: "fixed",
//             top: 10,
//             left: 10,
//             zIndex: 1300,
//             backgroundColor: SIDEBAR_BG,
//             color: "#fff",
//             borderRadius: "10px",
//             boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
//             "&:hover": { backgroundColor: SIDEBAR_ACTIVE },
//           }}
//         >
//           <MenuIcon />
//         </IconButton>
//       )}

//       {/* Mobile: SwipeableDrawer */}
//       {isMobile && (
//         <SwipeableDrawer
//           anchor="left"
//           open={mobileOpen}
//           onClose={() => setMobileOpen(false)}
//           onOpen={() => setMobileOpen(true)}
//           PaperProps={{
//             sx: { backgroundColor: SIDEBAR_BG, border: "none", width: 280 },
//           }}
//         >
//           {list()}
//         </SwipeableDrawer>
//       )}

//       {/* Tablet & Desktop: Permanent Drawer */}
//       {!isMobile && (
//         <Drawer
//           variant="permanent"
//           anchor="left"
//           PaperProps={{
//             sx: {
//               width: drawerWidth,
//               border: "none",
//               backgroundColor: SIDEBAR_BG,
//               transition: "width 0.3s ease",
//               overflowX: "hidden",
//             },
//           }}
//         >
//           {list()}
//         </Drawer>
//       )}

//       {/* Logout Dialog */}
//       <Dialog
//         open={openLogoutDialog}
//         onClose={() => setOpenLogoutDialog(false)}
//         PaperProps={{ sx: { borderRadius: "12px", minWidth: 320 } }}
//       >
//         <DialogTitle sx={{ fontWeight: 600, color: "#122b2a" }}>Logout</DialogTitle>
//         <DialogContent>
//           <DialogContentText>Are you sure you want to logout?</DialogContentText>
//         </DialogContent>
//         <DialogActions sx={{ px: 3, pb: 2 }}>
//           <Button onClick={() => setOpenLogoutDialog(false)} sx={{ color: "#666", borderRadius: "8px" }}>
//             No
//           </Button>
//           <Button
//             onClick={handleLogoutConfirm}
//             variant="contained"
//             disabled={loading}
//             sx={{
//               borderRadius: "8px",
//               backgroundColor: "#ef4444",
//               "&:hover": { backgroundColor: "#dc2626" },
//             }}
//           >
//             {loading ? <CircularProgress size={20} sx={{ color: "#fff" }} /> : "Yes"}
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </Box>
//   );
// }


import React, { useState } from "react";
import Box from "@mui/material/Box";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Typography from "@mui/material/Typography";
import Avatar from "@mui/material/Avatar";
import IconButton from "@mui/material/IconButton";
import Collapse from "@mui/material/Collapse";
import useMediaQuery from "@mui/material/useMediaQuery";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Tooltip from "@mui/material/Tooltip";

import DashboardIcon from "@mui/icons-material/Dashboard";
import PeopleIcon from "@mui/icons-material/People";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import SmsIcon from "@mui/icons-material/Sms";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import MasksIcon from "@mui/icons-material/Masks";
import HealingIcon from "@mui/icons-material/Healing";
import Diversity3Icon from "@mui/icons-material/Diversity3";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import ExpandMore from "@mui/icons-material/ExpandMore";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";

import { Link, useLocation, useNavigate } from "react-router-dom";
import ClinicLogo from "../../Assets/logo.png";
import {
  getDecryptedData,
  getDecryptedUserType,
} from "../../Utils/LoginUserDetails.js/LoginUserSavedDetails";

const SIDEBAR_BG = "#122b2a";
const SIDEBAR_HOVER = "#1a3d3b";
const SIDEBAR_ACTIVE = "#1c7c6c";
const SIDEBAR_TEXT = "rgba(255,255,255,0.7)";
const SIDEBAR_TEXT_ACTIVE = "#fff";
const SIDEBAR_BORDER = "rgba(255,255,255,0.08)";
const TEAL_ACCENT = "#2ec4a5";

const DESKTOP_BP = "(min-width:1200px)";
const TABLET_BP = "(min-width:768px) and (max-width:1199px)";
const MOBILE_BP = "(max-width:767px)";

export default function RiteAdminSidebar({ onSidebarChange }) {

  const [mobileOpen, setMobileOpen] = useState(false);
  const [openLogoutDialog, setOpenLogoutDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const [collapsed, setCollapsed] = useState(false);
  const [openSection, setOpenSection] = useState(null);

  const isDesktop = useMediaQuery(DESKTOP_BP);
  const isTablet = useMediaQuery(TABLET_BP);
  const isMobile = useMediaQuery(MOBILE_BP);

  const location = useLocation();
  const navigate = useNavigate();

  const LoginUserDetails = getDecryptedData();
  const LoginUserType = getDecryptedUserType();

  const fullName = `${LoginUserDetails?.first_name || ""} ${LoginUserDetails?.last_name || ""}`.trim();

  /* ================= ROLE BASE PATH ================= */

  const roleBase = {
    super_admin: "/rite-admin",
    admin: "/rite-admin",
    manager: "/rite-manager",
    marketer: "/rite-marketer",
    staff: "/rite-staff",
    developer: "/rite-developer",
  };

  const basePath = roleBase[LoginUserType] || "/rite-admin";

  const isCollapsed = isTablet ? true : collapsed;
  const drawerWidth = isCollapsed ? 64 : 240;

  React.useEffect(() => {
    if (onSidebarChange) {
      if (isMobile) onSidebarChange(0);
      else onSidebarChange(drawerWidth);
    }
  }, [drawerWidth, isMobile, onSidebarChange]);

  const handleLogoutConfirm = () => {
    setLoading(true);
    setTimeout(() => {
      sessionStorage.clear();
      navigate("/rite-admin-signin");
    }, 2000);
  };

  const isActive = (path) => location.pathname === path;

  /* ================= MENU ITEMS ================= */

  const commonItems = [
    { text: "Dashboard", icon: <DashboardIcon />, path: `${basePath}/dashboard` },
    { text: "Clients", icon: <PeopleIcon />, path: `${basePath}/rite-clients` },
    { text: "Rite Staff", icon: <SmsIcon />, path: `${basePath}/send-messages` },
    { text: "Demo Bokings", icon: <CalendarMonthIcon />, path: `${basePath}/appointments` },
    { text: "Emails", icon: <AccessTimeIcon />, path: `${basePath}/my-schedule` },
  ];

  const riteItems = [
    { text: "Rite Staff", path: `${basePath}/rite-staff`, icon: <MasksIcon /> },
    { text: "Rite Departments", path: `${basePath}/rite-departments`, icon: <HealingIcon /> },
    { text: "Rite Categories", path: `${basePath}/rite-categories`, icon: <ChevronRightIcon /> },
    { text: "Restaurant Customers Form", path: `${basePath}/restaurant-customers-form`, icon: <ChevronRightIcon /> },
  ];

  /* ================= NAV ITEM ================= */

  const NavItem = ({ item }) => {

    const button = (
      <ListItem disablePadding sx={{ mb: 0.25 }}>
        <ListItemButton
          component={Link}
          to={item.path}
          onClick={() => isMobile && setMobileOpen(false)}
          sx={{
            borderRadius: "8px",
            mx: isCollapsed ? 0.5 : 1,
            px: isCollapsed ? 1.5 : 2,
            py: 1,
            minHeight: 42,
            justifyContent: isCollapsed ? "center" : "flex-start",
            backgroundColor: isActive(item.path) ? SIDEBAR_ACTIVE : "transparent",
            color: isActive(item.path) ? SIDEBAR_TEXT_ACTIVE : SIDEBAR_TEXT,
            "&:hover": {
              backgroundColor: isActive(item.path) ? SIDEBAR_ACTIVE : SIDEBAR_HOVER,
              color: SIDEBAR_TEXT_ACTIVE,
            },
          }}
        >
          <ListItemIcon
            sx={{
              color: isActive(item.path) ? SIDEBAR_TEXT_ACTIVE : SIDEBAR_TEXT,
              minWidth: isCollapsed ? 0 : 36,
              mr: isCollapsed ? 0 : 1,
            }}
          >
            {item.icon}
          </ListItemIcon>

          {!isCollapsed && (
            <ListItemText
              primary={item.text}
              primaryTypographyProps={{
                fontSize: 13,
                fontWeight: isActive(item.path) ? 600 : 400,
              }}
            />
          )}
        </ListItemButton>
      </ListItem>
    );

    return isCollapsed ? (
      <Tooltip title={item.text} placement="right">{button}</Tooltip>
    ) : button;
  };

  /* ================= COLLAPSIBLE ================= */

  const CollapsibleSection = ({ title, icon, sectionKey, items }) => (
    <>
      <ListItem disablePadding>
        <ListItemButton
          onClick={() =>
            setOpenSection(openSection === sectionKey ? null : sectionKey)
          }
          sx={{
            borderRadius: "8px",
            mx: 1,
            py: 1,
            color: SIDEBAR_TEXT,
            "&:hover": { backgroundColor: SIDEBAR_HOVER },
          }}
        >
          <ListItemIcon sx={{ color: SIDEBAR_TEXT }}>{icon}</ListItemIcon>

          {!isCollapsed && (
            <>
              <ListItemText primary={title} />
              {openSection === sectionKey ? <ExpandLess /> : <ExpandMore />}
            </>
          )}
        </ListItemButton>
      </ListItem>

      {!isCollapsed && (
        <Collapse in={openSection === sectionKey}>
          <List sx={{ pl: 2 }}>
            {items.map((item) => (
              <NavItem key={item.text} item={item} />
            ))}
          </List>
        </Collapse>
      )}
    </>
  );

  /* ================= SIDEBAR ================= */

  const list = () => (
    <Box
      sx={{
        width: isMobile ? 280 : drawerWidth,
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        backgroundColor: SIDEBAR_BG,
      }}
    >

      {/* Logo */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          px: 2,
          py: 2,
          borderBottom: `1px solid ${SIDEBAR_BORDER}`,
        }}
      >
        <img src={ClinicLogo} alt="logo" style={{ height: 28 }} />
      </Box>

      {/* Menu */}
      <Box sx={{ flex: 1, overflowY: "auto", py: 1 }}>
        <List disablePadding>
          {commonItems.map((item) => (
            <NavItem key={item.text} item={item} />
          ))}
        </List>

        {(LoginUserType === "admin" || LoginUserType === "super_admin") && (
          <>
            <Divider sx={{ borderColor: SIDEBAR_BORDER, my: 1 }} />

            <List disablePadding>

              <CollapsibleSection
                title="Rite Management"
                icon={<HealingIcon />}
                sectionKey="rite"
                items={riteItems}
              />

              <NavItem
                item={{
                  text: "Enquiries",
                  icon: <Diversity3Icon />,
                  path: `${basePath}/all-enquiries`,
                }}
              />

            </List>
          </>
        )}
      </Box>

      {/* Profile + Logout */}
      <Box sx={{ borderTop: `1px solid ${SIDEBAR_BORDER}`, p: 1.5 }}>

        {!isCollapsed && (
          <ListItemButton
            component={Link}
            to={`${basePath}/user-profile`}
            sx={{ borderRadius: 2, mb: 1 }}
          >
            <Avatar
              sx={{
                width: 36,
                height: 36,
                backgroundColor: "rgba(46,196,165,0.2)",
                color: TEAL_ACCENT,
                mr: 1.5,
              }}
            >
              {LoginUserDetails?.first_name?.[0]?.toUpperCase() || "U"}
            </Avatar>

            <Box>
              <Typography sx={{ fontSize: 13, color: "#fff", fontWeight: 600 }}>
                {fullName}
              </Typography>
              <Typography sx={{ fontSize: 11, color: "rgba(255,255,255,0.4)" }}>
                {LoginUserType}
              </Typography>
            </Box>
          </ListItemButton>
        )}

        <ListItemButton
          onClick={() => setOpenLogoutDialog(true)}
          sx={{
            borderRadius: 2,
            color: "rgba(255,255,255,0.4)",
            "&:hover": { color: "#ef4444" },
          }}
        >
          <PowerSettingsNewIcon sx={{ mr: isCollapsed ? 0 : 1 }} />
          {!isCollapsed && <Typography sx={{ fontSize: 12 }}>Logout</Typography>}
        </ListItemButton>
      </Box>
    </Box>
  );

  return (
    <Box>

      {isMobile && (
        <IconButton
          onClick={() => setMobileOpen(true)}
          sx={{
            position: "fixed",
            top: 10,
            left: 10,
            zIndex: 1300,
            backgroundColor: SIDEBAR_BG,
            color: "#fff",
          }}
        >
          <MenuIcon />
        </IconButton>
      )}

      {isMobile ? (
        <SwipeableDrawer
          anchor="left"
          open={mobileOpen}
          onClose={() => setMobileOpen(false)}
          onOpen={() => setMobileOpen(true)}
        >
          {list()}
        </SwipeableDrawer>
      ) : (
        <Drawer variant="permanent">{list()}</Drawer>
      )}

      {/* Logout Dialog */}
      <Dialog open={openLogoutDialog}>
        <DialogTitle>Logout</DialogTitle>

        <DialogContent>
          <DialogContentText>
            Are you sure you want to logout?
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setOpenLogoutDialog(false)}>Cancel</Button>

          <Button
            variant="contained"
            onClick={handleLogoutConfirm}
            disabled={loading}
          >
            {loading ? <CircularProgress size={20} /> : "Logout"}
          </Button>
        </DialogActions>
      </Dialog>

    </Box>
  );
}